// extracted by mini-css-extract-plugin
module.exports = {"root":"az_GI","disabled":"az_HI","input":"az_II","checkmark-container":"az_JI","checkmark-border":"az_KI","checkmark-box":"az_LI","checkmark":"az_MI","label-text":"az_NI"};